/* Move the existing controls, never clone fields or detach them from their widget/form. */
(() => {
  function orderLighting(root) {
    root.querySelectorAll('[data-personalize-pilot-widget]').forEach((widget) => {
      const fields = widget.querySelector('.personalize-pilot-widget__fields');
      const lighting = widget.querySelector('.personalize-pilot-widget__lighting');
      if (!fields || !lighting || lighting.parentElement !== fields) return;
      const arrangement = widget.querySelector('.definition-editor__arrangement');
      // The dictionary editor adds this after the fields asynchronously. It is
      // still a text-setting control, so keep it before the final light choice.
      if (arrangement && (arrangement.parentElement === fields.parentElement || arrangement.parentElement === fields) && arrangement.nextElementSibling !== lighting) {
        fields.insertBefore(arrangement, lighting);
      }
      if (fields.lastElementChild !== lighting) fields.append(lighting);
      lighting.dataset.productOptionOrder = 'after-personalization';
    });
  }

  function install(root) {
    orderLighting(root);
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.optionOrderInstalled) return;
      section.dataset.optionOrderInstalled = 'true';
      const observer = new MutationObserver((records) => {
        const changedFields = records.some((record) =>
          record.target.matches?.('.personalize-pilot-widget__fields') ||
          Array.from(record.addedNodes).some((node) => node.nodeType === 1 &&
            (node.matches('[data-personalize-pilot-widget], .definition-editor__arrangement') || node.querySelector('[data-personalize-pilot-widget]')))
        );
        // Du, in Worten appends its paragraph fields after asynchronous library loading.
        // Moving once more is idempotent; the observer's own mutation causes no further move.
        if (changedFields) orderLighting(section);
      });
      observer.observe(section, { childList: true, subtree: true });
      section.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => install(document), { once: true });
  } else {
    install(document);
  }
  document.addEventListener('shopify:section:load', (event) => install(event.target));
})();
